// src/features/system/tenants/api/tenantsApi.ts
import { bff } from '@/lib/http/bff';

export interface Tenant {
  id_tenant: number;
  tenant_name: string;
  code: string;
  display_name?: string | null;
  description?: string | null;
  active?: boolean | null;
  service_ids?: number[];
}

export interface TenantCreateIn  { tenant_name: string; service_ids: number[] }
export interface TenantCreateOut { id_tenant: number }

const BASE = '/tenants'; // BFF base (bff client already prefixes /bff)

export const fetchTenants = (): Promise<Tenant[]> =>
  bff.get<Tenant[]>(`${BASE}`);

export const createTenant = (payload: TenantCreateIn): Promise<TenantCreateOut> =>
  bff.post<TenantCreateOut, TenantCreateIn>(`${BASE}/create`, payload);
